<script>

    let fName;
    let lName;
    let email;
    let pw;
    let cPw;

    export let callback;

    let confirmPw_error = false;

    let submitForm = () => {
        if (pw === cPw) {
            let register_data = {
                'lastname' : lName,
                'firstname' : fName,
                'email' : email,
                'pw' : pw,
            }
            register_data = JSON.stringify(register_data);
            confirmPw_error = false;
            callback();
        }
        else {
            confirmPw_error = true
        }

    }

</script>

<div class="register_container">

    <div class="register_wrapper">

        <div class="logo">

            <img src="assets/svgs/logo.svg" alt="">

        </div>

        <form class="form inputs" on:submit|preventDefault={submitForm}>

            <div class="input_container">

                <input bind:value={fName} type="text" placeholder="First Name" required>

            </div>
            <div class="input_container">

                <input bind:value={lName} type="text" placeholder="Last Name" required>

            </div>
            <div class="input_container">

                <input bind:value={email} type="email" placeholder="Email" required>

            </div>
            <div class="input_container">

                <input bind:value={pw} type="password" placeholder="Password" required>

            </div>
            <div class="input_container">

                <input bind:value={cPw} type="password" placeholder="Confirm Password" required>
                {#if confirmPw_error}
                    <span class="login_error">Passwords are not the same</span>
                {/if}

            </div>

            <div class="btn-container">

                <button class="btn" type="submit">Register</button>

            </div>

        </form>


    </div>

</div>

<style>

    .register_container {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .register_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        width: 80%;
    }
    .logo {
        margin-top: 3vh;
    }
    .form {
        margin-top: 10vh;
    }
    .btn-container {
        margin-top: 7vh;
    }
    .input_container {
        margin-bottom: 5vh;
    }
    .login_error {
        position: absolute;
        top: 101%;
        left: 0;
        color: red;
    }

</style>